import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { ModalCTA } from 'containers/misc'
import { Button, List } from 'components/misc'

const listActions = [
  {
    id: 1,
    label: 'Send confirmation email again',
    intlKey: 'participant.send_confirmation_email_again',
    action: 'sendConfirmationEmail',
    url: '/'
  }
]

export default class LeaderSettings extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    sendConfirmationEmail: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired
  }

  state = {
    sendResendConfirmationEmailDialogOpen: false
  }

  handleItemSelect = action => {
    this.setState({
      sendResendConfirmationEmailDialogOpen: action === 'sendConfirmationEmail'
    })
  }

  handleDialogClose = () =>
    this.setState({
      sendResendConfirmationEmailDialogOpen: false
    })

  render() {
    const { sendConfirmationEmail, data } = this.props
    const { sendResendConfirmationEmailDialogOpen } = this.state

    const filterActions = listActions.filter(item => {
      if (!item.displayFor) {
        return item
      }
      return item.displayFor === get(data, 'personState.value')
    })

    const closeButton = (
      <div className="col-xs-6">
        <Button type="button" onClick={this.handleDialogClose} secondary>
          <FormattedMessage id="button.close" defaultMessage="Close" />
        </Button>
      </div>
    )

    return (
      <div>
        <div className="row">
          <div className="col-xs-12" style={{ marginBottom: 15 }}>
            <List data={filterActions} onSelect={this.handleItemSelect} />
          </div>
        </div>
        {sendResendConfirmationEmailDialogOpen &&
          <ModalCTA>
            <div className="row">
              <div className="col-xs-12">
                <h2 className="text--center">
                  <FormattedMessage
                    id="participant.send_confirmation_email_again_question"
                    defaultMessage="Send confirmation email again?"
                  />
                </h2>
              </div>
              {closeButton}
              <div className="col-xs-6 text--right">
                <Button
                  type="button"
                  negative
                  onClick={() => sendConfirmationEmail(get(data, 'id'))}
                >
                  <FormattedMessage
                    id="button.confirm"
                    defaultMessage="Confirm"
                  />
                </Button>
              </div>
            </div>
          </ModalCTA>}
        <div className="base-margin--top">
          <div className="row">
            <div className="col-xs-6">
              <Button
                type="button"
                intlKey="button.close"
                secondary
                onClick={() => this.props.modal(null)}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
